export interface IAppendQueryParamsOptions {
  clearEmpty?: boolean;
  booleanAsString?: boolean;
}
export function appendQueryParams<T = Record<string, unknown>>(
  path: string,
  params: T,
  options: IAppendQueryParamsOptions = {},
): string {
  const { booleanAsString = false, clearEmpty = false } = options;

  const empty = [null, undefined, ''] as Array<unknown>;
  const entries = Object.entries(params || {});
  const filteredParams = !clearEmpty
    ? entries
    : entries.filter(([, value]) => !empty.includes(value));

  const arrayParams = filteredParams.map(([key, value]) => {
    if (typeof value === 'boolean') {
      if (booleanAsString) {
        value = value ? 'true' : 'false';
      } else {
        value = value ? 1 : 0;
      }
    }
    return `${key}=${value}`;
  });
  const segments = path.split('?');
  const basePath = segments[0];
  const queryParams = segments[1] ? [segments[1], ...arrayParams] : arrayParams;

  return queryParams.length ? `${basePath}?${queryParams.join('&')}` : basePath;
}
